export default __webpack_public_path__ + "static/media/android-chrome-512x512.3ba27ff5.png";